'use client'

import cn from 'clsx'
import { usePathname } from 'next/navigation'
import { useImperativeHandle, useRef, useState } from 'react'
import { Marquee } from '~/components/marquee'
import { useGlobalTransitionRefs } from '~/components/page-transition/context'
import { BANNER_TEXT } from '~/libs/constants'
import s from './banner.module.css'

const visiblePages = ['/work', '/store', '/contact', '/about', '/read']

export function Banner() {
  const pathname = usePathname()
  const [speed, setSpeed] = useState(1)
  const bannerRef = useRef(null)

  useImperativeHandle(bannerRef, () => ({
    setSpeed: (speed) => {
      setSpeed(speed)
    },
  }))

  useGlobalTransitionRefs({
    banner: bannerRef,
  })

  if (!visiblePages.includes(pathname)) {
    return null
  }

  const text = BANNER_TEXT[pathname] || ''

  return (
    <div
      id="banner"
      className={cn(
        s.container,
        'absolute left-0 top-0 sh-74 dt:sh-154 w-full mt-header-height grid place-items-center banner max-w-screen overflow-hidden spt-6 dt:spt-18'
      )}
    >
      <Marquee
        id="marquee"
        repeat={10}
        speed={speed}
        className="px-safe"
        startFromZero
      >
        <span className="inline-block smr-56 dt:smr-216">{`${text} `}</span>
      </Marquee>
    </div>
  )
}
